var _a, _b, _c, _d;
/* eslint-disable sonarjs/no-duplicate-string -- This rule was disabled because the repetition of strings is intended in this file */
import { DesignTokenSizeEnum, } from './definitions';
import { fonts, mainThemeColors, invertedThemeColors, appearances, } from '@volkswagen-onehub/tokens';
/**
 * This map contains values to be used with sizes and spacings.
 */
const sizesAndSpacings = Object.keys(DesignTokenSizeEnum).reduce((acc, key) => {
    acc[key] = `size.${key}`;
    return acc;
}, {
    line: {
        default: 'size.line100',
        active: 'size.line200',
    },
    border: {
        light: 'size.line100',
        heavy: 'size.line200',
    },
});
/**
 * Set of available UI themes
 *
 * "main" theme must be a complete UI theme, all other themes defined here can be
 * a partial definition, missing values will be inherited from "main"
 */
const main = {
    animation: {
        timingFunction: {
            in: 'animation.timingFunction.timing100',
            out: 'animation.timingFunction.timing100',
            linear: 'animation.timingFunction.timing200',
            cubicOut: 'animation.timingFunction.timing300',
            navigation: 'animation.timingFunction.timing400',
        },
        duration: {
            collapsible: 'animation.duration.duration600',
            color: 'animation.duration.duration300',
            layer: 'animation.duration.duration300',
            scrollIndicator: 'animation.duration.duration2000',
            nba: 'animation.duration.duration300',
            tabIndicator: 'animation.duration.duration300',
            statusIndicator: 'animation.duration.duration400',
        },
    },
    global: {
        backgroundColor: 'color.white-000',
        secondaryBackgroundColor: 'color.grey-100',
        shimColor: 'color.black-000-transparent-60',
        eyeCatcherColor: 'color.mint-100',
        lightBackground: 'color.black-000-transparent-05',
        pinkEyeCatcherColor: 'color.pink-100',
        optionBlueHover: 'color.blue-400',
    },
    option: {
        checkedBackground: 'color.blue-900',
        checkedColor: 'color.white-000',
        checkedHover: 'color.blue-600',
        checkedDisabledBackground: 'color.grey-300',
        hover: 'color.grey-100',
    },
    navigation: {
        backgroundColor: 'color.white-000',
        backgroundTransparency: 'color.white-000-transparent-98',
    },
    transparentColor: 'color.transparent',
    hoverIndicatorColor: {
        filledElement: {
            default: 'color.white-000-transparent-20',
            active: 'color.white-000-transparent-40',
        },
        outlinedElement: {
            default: 'color.grey-200-transparent-20',
            active: 'color.white-000-transparent-20',
        },
    },
    decoratorColor: 'color.blue-200',
    focusColor: 'color.blue-100',
    focus: {
        background: 'color.blue-350',
        foreground: 'color.white-000',
    },
    separatorColor: 'color.grey-100',
    backgroundGradient: {
        darkColor: 'color.blue-600',
        lightColor: 'color.blue-500',
    },
    validation: {
        success: 'color.green-100',
        error: 'color.red-100',
    },
    video: {
        background: 'color.black-000',
    },
    shim: {
        keepContext: 'color.black-000-transparent-10',
        hideContext: 'color.black-000-transparent-50',
        enhanceContrast: 'color.black-000-transparent-80',
    },
    interaction: {
        recipe100: {
            default: 'color.black-000',
            hover: 'color.grey-400',
            active: 'color.grey-400',
            disabled: 'color.grey-100',
            checked: 'color.black-000',
        },
        recipe150: {
            default: 'color.grey-100',
            hover: 'color.grey-100',
            active: 'color.grey-100',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
        recipe200: {
            default: 'color.grey-400',
            hover: 'color.grey-300',
            active: 'color.grey-300',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
        recipe250: {
            default: 'color.blue-200',
            hover: 'color.blue-100',
            active: 'color.blue-100',
            disabled: 'color.grey-100',
            checked: 'color.blue-200',
        },
        recipe300: {
            default: 'color.blue-600',
            hover: 'color.blue-600',
            active: 'color.blue-600',
            disabled: 'color.grey-400',
            checked: 'color.blue-600',
        },
        recipe350: {
            default: 'color.green-200',
            hover: 'color.green-100',
            active: 'color.green-100',
            disabled: 'color.green-200',
            checked: 'color.green-200',
        },
        recipe360: {
            default: 'color.red-200',
            hover: 'color.red-100',
            active: 'color.red-100',
            disabled: 'color.red-200',
            checked: 'color.red-200',
        },
        recipe370: {
            default: 'color.purple-100',
            hover: 'color.purple-100',
            active: 'color.purple-100',
            disabled: 'color.grey-100',
            checked: 'color.purple-100',
        },
        recipe380: {
            default: 'color.yellow-000',
            hover: 'color.yellow-000',
            active: 'color.yellow-000',
            disabled: 'color.grey-100',
            checked: 'color.yellow-000',
        },
        recipe400: {
            default: 'color.blue-600',
            hover: 'color.blue-900',
            active: 'color.blue-900',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
        recipe450: {
            default: 'color.blue-600',
            hover: 'color.blue-900',
            active: 'color.blue-900',
            disabled: 'color.grey-400',
            checked: 'color.blue-600',
        },
        recipe500: {
            default: 'color.blue-600',
            hover: 'color.blue-600',
            active: 'color.blue-600',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
        recipe550: {
            default: 'color.grey-200',
            hover: 'color.grey-100',
            active: 'color.grey-100',
            checked: 'color.grey-200',
        },
        recipe600: {
            default: 'color.grey-500',
            hover: 'color.grey-400',
            active: 'color.grey-400',
            checked: 'color.grey-500',
        },
        recipe700: {
            default: 'color.grey-100',
            hover: 'color.grey-400',
            active: 'color.grey-400',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
        recipe750: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.black-000',
            checked: 'color.white-000',
        },
        recipe800: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.grey-200',
            checked: 'color.blue-600',
        },
        recipe850: {
            default: 'color.black-000',
            hover: 'color.black-000',
            active: 'color.black-000',
            disabled: 'color.white-000',
            checked: 'color.white-000',
        },
        recipe925: {
            default: 'color.blue-600',
            hover: 'color.blue-900',
            active: 'color.blue-900',
            disabled: 'color.grey-200',
            checked: 'color.blue-900',
        },
        recipe950: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.white-000',
            checked: 'color.white-000',
        },
    },
    size: sizesAndSpacings,
    shadows: {
        variant1: 'shadows.variant1',
        variant2: 'shadows.variant2',
        variant3: 'shadows.variant3',
        variant4: 'shadows.variant4',
    },
    fonts: fonts,
    appearances: appearances,
    colors: mainThemeColors,
    text: {
        color: {
            primary: 'color.black-000',
            primaryHover: 'color.grey-300',
            secondary: 'color.grey-400',
        },
        weight: {
            regular: 'font.weight.regular',
            light: 'font.weight.light',
            bold: 'font.weight.bold',
        },
        background: {
            primary: 'color.white-000',
        },
    },
    border: {
        color: {
            primary: 'color.blue-600',
            secondary: 'color.grey-100',
        },
    },
    referenceBadge: {
        backgroundColor: {
            default: 'color.grey-100',
            active: 'color.blue-900',
        },
        textColor: {
            default: 'color.black-000',
            active: 'color.white-000',
        },
        outlineColor: 'color.transparent',
    },
    nextBestAction: {
        transition: {
            backgroundColor: 'color.white-000',
        },
    },
    tooltip: {
        backgroundColor: 'color.black-000',
        textColor: 'color.white-000',
    },
};
const inverted = {
    global: {
        backgroundColor: 'color.blue-600',
        secondaryBackgroundColor: 'color.blue-600',
        shimColor: 'color.black-000-transparent-60',
    },
    option: {
        checkedBackground: 'color.white-000',
        checkedColor: 'color.blue-600',
        checkedHover: 'color.grey-100',
        checkedDisabledBackground: 'color.grey-400',
        hover: 'color.blue-500',
    },
    hoverIndicatorColor: {
        filledElement: {
            default: 'color.grey-200-transparent-20',
            active: 'color.white-000-transparent-20',
        },
    },
    interaction: {
        recipe100: {
            default: 'color.white-000',
            hover: 'color.grey-200',
            active: 'color.grey-200',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe150: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.grey-400',
            checked: 'color.blue-200',
        },
        recipe200: {
            default: 'color.grey-200',
            hover: 'color.grey-100',
            active: 'color.grey-100',
            disabled: 'color.grey-400',
            checked: 'color.blue-200',
        },
        recipe400: {
            default: 'color.blue-200',
            hover: 'color.blue-100',
            active: 'color.blue-100',
            disabled: 'color.grey-400',
            checked: 'color.blue-200',
        },
        recipe450: {
            default: 'color.white-000',
            hover: 'color.blue-100',
            active: 'color.blue-100',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe500: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe750: {
            default: 'color.blue-600',
            hover: 'color.blue-600',
            active: 'color.blue-600',
            disabled: 'color.grey-100',
            checked: 'color.blue-600',
        },
    },
    text: {
        color: { primary: 'color.white-000', secondary: 'color.grey-200' },
        background: {
            primary: 'color.black-000',
        },
    },
    navigation: {
        backgroundColor: 'color.blue-600',
    },
    referenceBadge: {
        backgroundColor: {
            default: 'color.blue-600',
            active: 'color.white-000',
        },
        textColor: {
            default: 'color.white-000',
            active: 'color.blue-600',
        },
        outlineColor: 'color.white-000',
    },
    tooltip: {
        backgroundColor: 'color.grey-100',
        textColor: 'color.black-000',
    },
    colors: invertedThemeColors,
};
const image = {
    interaction: {
        recipe100: {
            default: 'color.white-000',
            hover: 'color.blue-100',
            active: 'color.blue-100',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe150: {
            default: 'color.white-000',
            hover: 'color.white-000',
            active: 'color.white-000',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe200: (_a = inverted === null || inverted === void 0 ? void 0 : inverted.interaction) === null || _a === void 0 ? void 0 : _a.recipe200,
        recipe400: {
            default: 'color.white-000',
            hover: 'color.blue-100',
            active: 'color.blue-100',
            disabled: 'color.grey-400',
            checked: 'color.white-000',
        },
        recipe450: (_b = inverted === null || inverted === void 0 ? void 0 : inverted.interaction) === null || _b === void 0 ? void 0 : _b.recipe450,
        recipe500: (_c = inverted === null || inverted === void 0 ? void 0 : inverted.interaction) === null || _c === void 0 ? void 0 : _c.recipe500,
        recipe750: (_d = inverted === null || inverted === void 0 ? void 0 : inverted.interaction) === null || _d === void 0 ? void 0 : _d.recipe750,
    },
    text: {
        color: { primary: 'color.white-000', secondary: 'color.white-000' },
        background: {
            primary: 'color.black-000',
        },
    },
    navigation: {
        backgroundColor: 'color.transparent',
    },
    focusColor: 'color.white-000',
    referenceBadge: {
        backgroundColor: {
            default: 'color.black-000-transparent-80',
            active: 'color.blue-200',
        },
        textColor: {
            default: 'color.white-000',
            active: 'color.black-000',
        },
        outlineColor: 'color.transparent',
    },
};
export const themeSet = {
    main,
    inverted,
    image,
};
